/* Store the specifications categories in a JSON file */
export const SpecCategories = {
	Torque: {
		order: 1,
		specifications: [
			'Max_looseningTorque_unit_SI',
			'Max_looseningTorque_unit_USCS',
			'Max_Torque_unit_lbf_ft_SI',
			'Max_Torque_unit_lbf_ft_USCS',
			'Max_Torque_unit_lbf_in_SI',
			'Max_Torque_unit_lbf_in_USCS',
			'Max_Torque_unit_Nm_SI',
			'Max_Torque_unit_Nm_USCS',
			'Max_Torque_unit_SI',
			'Max_Torque_unit_USCS',
			'Max_WorkingTorqueFwd_unit_SI',
			'Max_WorkingTorqueFwd_unit_USCS',
			'Max_WorkingTorqueRev_unit_SI',
			'Max_WorkingTorqueRev_unit_USCS',
			'MaxRundownTorque_unit_SI',
			'MaxRundownTorque_unit_USCS',
			'MaxTappingTorque_unit_SI',
			'MaxTappingTorque_unit_USCS',
			'MaxTappingTorqueHighSpeed_unit_SI',
			'MaxTappingTorqueHighSpeed_unit_USCS',
			'MaxTappingTorqueLowSpeed_unit_SI',
			'MaxTappingTorqueLowSpeed_unit_USCS',
			'MaxTorqueCapacity_SI',
			'MaxTorqueCapacity_USCS',
			'MaxTorqueFwd_unit_SI',
			'MaxTorqueFwd_unit_USCS',
			'MaxTorqueRev_unit_SI',
			'MaxTorqueRev_unit_USCS',
			'Min_StartingTorque_unit_SI',
			'Min_StartingTorque_unit_USCS',
			'Min_Torque_unit_lbf_ft_SI',
			'Min_Torque_unit_lbf_ft_USCS',
			'Min_Torque_unit_lbf_in_SI',
			'Min_Torque_unit_lbf_in_USCS',
			'Min_Torque_unit_Nm_SI',
			'Min_Torque_unit_Nm_USCS',
			'Min_Torque_unit_SI',
			'Min_Torque_unit_USCS',
			'Min_TorqueFwd_unit_SI',
			'Min_TorqueFwd_unit_USCS',
			'Min_WorkingTorqueFwd_unit_SI',
			'Min_WorkingTorqueFwd_unit_USCS',
			'Min_WorkingTorqueRev_unit_SI',
			'Min_WorkingTorqueRev_unit_USCS',
			'MinTorqueCapacity_SI',
			'MinTorqueCapacity_USCS',
			'OverloadTorque_per',
			'OverloadTorque_SI',
			'OverloadTorque_USCS',
			'RecommendedTorque_unit_SI',
			'RecommendedTorque_unit_USCS',
			'StallTorque_unit_SI',
			'StallTorque_unit_USCS',
			'TorqueAtMaxPower_unit_SI',
			'TorqueAtMaxPower_unit_USCS',
			'TorqueControlSystem',
			'TorqueLimited',
			'TorqueTransducer',
		],
	},
	Speed: {
		order: 2,
		specifications: [
			'CuttingSpeed_unit_SI',
			'CuttingSpeed_unit_USCS',
			'FreeSpeed_unit_SI',
			'FreeSpeed_unit_USCS',
			'FreeSpeed18VMax_unit_SI',
			'FreeSpeed18VMax_unit_USCS',
			'FreeSpeed18VMin_unit_SI',
			'FreeSpeed18VMin_unit_USCS',
			'FreeSpeed36VMax_unit_SI',
			'FreeSpeed36VMax_unit_USCS',
			'FreeSpeed36VMin_unit_SI',
			'FreeSpeed36VMin_unit_USCS',
			'FreeSpeedAirConsumption_Normo_unit_SI',
			'FreeSpeedAirConsumption_Normo_unit_USCS',
			'FreeSpeedNumberOfPositions',
			'FreeSpeedPosition1_unit_SI',
			'FreeSpeedPosition1_unit_USCS',
			'FreeSpeedPosition2_unit_SI',
			'FreeSpeedPosition2_unit_USCS',
			'FreeSpeedPosition3_unit_SI',
			'FreeSpeedPosition3_unit_USCS',
			'FreeSpeedReverse_unit_SI',
			'FreeSpeedReverse_unit_USCS',
			'FreeSpeedReversePosition1_unit_SI',
			'FreeSpeedReversePosition1_unit_USCS',
			'HighSpeedSetting_unit_SI',
			'HighSpeedSetting_unit_USCS',
			'LowSpeedSetting_unit_SI',
			'LowSpeedSetting_unit_USCS',
			'MaxFreeSpeed_SI',
			'MaxFreeSpeed_USCS',
			'MAXFreeSpeedRange_unit_SI',
			'MAXFreeSpeedRange_unit_USCS',
			'MINFreeSpeedRange_unit_SI',
			'MINFreeSpeedRange_unit_USCS',
		],
	},
	'Design and functions': {
		order: 3,
		specifications: [
			'AbrasivePadAttachment',
			'Accuracy',
			'Adjustment',
			'AnalogTransducers',
			'AngleSpindleType',
			'AngleType',
			'Autobalancer',
			'BackHeadCoaxial',
			'BeltSize_in',
			'BeltSize_mm',
			'BladeLenght_unit_SI',
			'BladeLenght_unit_USCS',
			'BlowPerMinute',
			'Body',
			'ButtDiameter_unit_SI',
			'ButtDiameter_unit_USCS',
			'BypassMotor_CoolingAir',
			'Cablecrosssection_unit_SI',
			'Cablecrosssection_unit_USCS',
			'Cablecrosssection2',
			'CableLength_unit_SI',
			'CableLength_unit_USCS',
			'CableType',
			'CartridgesSize_in',
			'CartridgesSize_mm',
			'CartridgesVolume_unit_SI',
			'CartridgesVolume_unit_USCS',
			'ChiselShank',
			'ChiselShankDiameter_in',
			'ChiselShankDiameter_mm',
			'ChuckMaxCapacity_in',
			'ChuckMaxCapacity_mm',
			'ChuckMount',
			'ChuckType',
			'CircularAbrasivePadSize_in',
			'CircularAbrasivePadSize_mm',
			'ClampingForce',
			'ClutchHousing',
			'ClutchLubricationType',
			'ClutchType',
			'ColletMaxCapacity',
			'ColletMaxCapacity_mm',
			'ColletType',
			'Compressionforce_unit_SI',
			'Compressionforce_unit_USCS',
			'CuttingCapacityAluminum_unit_SI',
			'CuttingCapacityAluminum_unit_USCS',
			'CuttingCapacitySteel_unit_SI',
			'CuttingCapacitySteel_unit_USCS',
			'CuttingForm',
			'Cylinder',
			'Cylinderstroke_unit_SI',
			'Cylinderstroke_unit_USCS',
			'DeltaAbrasivePadSize_in',
			'DeltaAbrasivePadSize_mm',
			'DigitalTransducers',
			'Drive_in',
			'Drive_mm',
			'DrivingSystem',
			'End_fittingManagement',
			'Engines',
			'Exaust',
			'FilterShakerIncluded',
			'FlexibleHead',
			'FrontNutThreaded',
			'GaugeType',
			'GovernorType',
			'GuardMaxRotation_SI',
			'GuardMaxRotation_USCS',
			'GuardPositions',
			'HandleType',
			'HeadAngleDegree',
			'HeadType',
			'ImpactMecanism',
			'InputDriveType',
			'IntegratedCable',
			'JawType',
			'JointType',
			'LiftingOption',
			'MainMaterialType',
			'Max_LiftingCapacity_unit_USCS',
			'MotorLubricationFree',
			'NozzleDiameter_mm',
			'NozzleType',
			'NumberOfAssemblyProcess',
			'NumberOfCycles',
			'NumberOfPhasesPerCycle',
			'NumberOfPsets',
			'NumberOfStepsPerPset',
			'NutsertThreadSize',
			'Oilcapacity_unit_SI',
			'OperatingHumidity',
			'OrbitSize_in',
			'OrbitSize_mm',
			'OrbitType',
			'OutputDriveSize',
			'OutputDriveSize_mm',
			'Outputdrivetype',
			'OutputPressure_unit_SI',
			'OutputPressure_unit_USCS',
			'OutputRetainerType',
			'OutputSignal',
			'OutputSpindleSize_unit_SI',
			'OutputSpindleSize_unit_USCS',
			'OutputSpindleThread',
			'OutputType',
			'OverloadForce_SI',
			'OverloadForce_USCS',
			'OverspeedShuOff',
			'Pad',
			'PadHolesNumber',
			'PadType',
			'PalmGrip',
			'PhaseType',
			'PipeInsideDiamCapacity',
			'ProcessCapabilityTests',
			'ProtectionFuse',
			'PsetCurvesOKNOK',
			'PsetResultsOKNOK',
			'PsetResultsTorqueAngleDateTimeReport',
			'PullingForce_unit_SI',
			'PullingForce_unit_USCS',
			'PunchDiameter_unit_SI',
			'PunchDiameter_unit_USCS',
			'QualityStrategies',
			'RackSlotNumber',
			'ReactionBarType',
			'RectangleAbrasivePadSizeWxL_in',
			'RectangleAbrasivePadSizeWxL_mm',
			'ReleaseType',
			'ResultsMemoryCapacity',
			'ResultsTorqueAngleDateTimeReport',
			'ResultsValueOK_NOK',
			'Reversible',
			'RivetHammerType',
			'RivetType',
			'RotationDrive',
			'RotativeGuardType',
			'RotativeInlet',
			'ScaleResolution',
			'Screen',
			'ScrewHeadSize',
			'se.atlascopco.Hydraulic_brakes_max_ft_lb_decimal',
			'se.atlascopco.Hydraulic_brakes_max_Nm_decimal',
			'se.atlascopco.Hydraulic_brakes_min_ft_lb_decimal',
			'se.atlascopco.Hydraulic_brakes_min_Nm_decimal',
			'se.atlascopco.Static_transducer_max_lb_ft_decimal',
			'se.atlascopco.Static_transducer_max_Nm_decimal',
			'se.atlascopco.Static_transducer_min_lb_ft_decimal',
			'se.atlascopco.Static_transducer_min_Nm_decimal',
			'Sequence',
			'Settings',
			'ShaftLoadingCode',
			'ShavingCapacity_unit_SI',
			'ShavingCapacity_unit_USCS',
			'ShortCircuitCurrent',
			'SideHandle',
			'SignalType',
			'SpeedControl',
			'SpindleLock',
			'SpindleType',
			'SplineType',
			'StartingCurrent',
			'StartingSystem',
			'StorageHumidity',
			'Strategies',
			'StrokeLength_in',
			'StrokeLength_mm',
			'StrokePerMinute',
			'SupensionOption',
			'SwivelingGuard',
			'TelescopicStroke_unit_SI',
			'TelescopicStroke_unit_USCS',
			'ThroatGap_A_in',
			'ThroatGap_A_mm',
			'ThrustSensor',
			'ToolCompatibility',
			'ToolHolderDiameter_unit_SI',
			'ToolHolderDiameter_unit_USCS',
			'ToolSupport',
			'ToolTesting',
			'ToolType',
			'TotalYokeGap_G_in',
			'TotalYokeGap_G_mm',
			'TranducerType',
			'TriggerType',
			'TypeClass',
			'UnitMeasurementSupported',
			'Up14SynchronizedChannels',
			'Vacuum',
			'VacuumDegree_mmHg',
			'VacuumDepression_mmH2O_unit_SI',
			'VacuumDepression_mmH2O_unit_USCS',
			'VacuumHoseSize_unit_SI',
			'VacuumHoseSize_unit_USCS',
			'VibrationDamped',
			'VolumeContainer_unit_SI',
			'VolumeContainer_unit_USCS',
			'WheelDiameter_in',
			'WheelDiameter_mm',
			'WheelDiameter_unit_SI',
			'WheelDiameter_unit_USCS',
			'WheelInnerDiameter_unit_SI',
			'WheelInnerDiameter_unit_USCS',
			'WheelThickness_in',
			'WheelThickness_mm',
			'WheelType',
			'WireBrushSize_unit_SI',
			'WireBrushSize_unit_USCS',
			'WorkArea',
			'WorkpieceMaterial',
			'WrenchJointChecksJointAnalysis',
		],
	},
	'Size and weight': {
		order: 8,
		specifications: [
			'AbrasiveInnerDiamSize_unit_SI',
			'AbrasiveInnerDiamSize_unit_USCS',
			'AnvilWorkClearance_C_in',
			'AnvilWorkClearance_C_mm',
			'BatteryWeight_unit_SI',
			'BatteryWeight_unit_USCS',
			'BoreDiameter_unit_SI',
			'BoreDiameter_unit_USCS',
			'ClosedHeight_H_in',
			'ClosedHeight_H_mm',
			'Dim_HeightH_unit_SI',
			'Dim_HeightH_unit_USCS',
			'Dim_LengthL_unit_SI',
			'Dim_LengthL_unit_USCS',
			'Dim_WidthW_unit_SI',
			'Dim_WidthW_unit_USCS',
			'DimA_unit_SI',
			'DimA_unit_USCS',
			'DimB_unit_SI',
			'DimB_unit_USCS',
			'DimC_unit_SI',
			'DimC_unit_USCS',
			'DimD_unit_SI',
			'DimD_unit_USCS',
			'DimE_unit_SI',
			'DimE_unit_USCS',
			'DimF_unit_SI',
			'DimF_unit_USCS',
			'DimG_unit_SI',
			'DimG_unit_USCS',
			'DimH_unit_SI',
			'DimH_unit_USCS',
			'DimI_unit_SI',
			'DimI_unit_USCS',
			'DimJ_unit_SI',
			'DimJ_unit_USCS',
			'DimK_unit_SI',
			'DimK_unit_USCS',
			'DimM_unit_SI',
			'DimM_unit_USCS',
			'ExtensionHeight_unit_SI',
			'ExtensionHeight_unit_USCS',
			'FeedLength_mm',
			'FillingHoseLength_unit_SI',
			'FillingHoseLength_unit_USCS',
			'GaugeHousingDiameter_unit_SI',
			'GaugeHousingDiameter_unit_USCS',
			'HoseInnerDiameter_mm',
			'HoseLength_unit_SI',
			'HoseLength_unit_USCS',
			'HydraulicStroke_unit_SI',
			'HydraulicStroke_unit_USCS',
			'InputDriveSize',
			'LengthWithoutRatchet_unit_SI',
			'LengthWithoutRatchet_unit_USCS',
			'LeverArmLength_unit_SI',
			'LeverArmLength_unit_USCS',
			'LowerOffset_D_in',
			'LowerOffset_D_mm',
			'Max_heightwithextension_unit_SI',
			'Max_heightwithextension_unit_USCS',
			'Max_lifting_height_unit_SI',
			'Max_lifting_height_unit_USCS',
			'Max_ramlenght_unit_SI',
			'Max_SizeBlastingMat_unit_SI',
			'Max_SizeBlastingMat_unit_USCS',
			'Max_spacing_legs_unit_SI',
			'MaxRivetSize_in',
			'MaxRivetSize_mm',
			'MaxRivetSizeAluminium_in',
			'MaxRivetSizeAluminium_mm',
			'MaxRivetSizeSteel_in',
			'MaxRivetSizeSteel_mm',
			'MaxStrokeLength_unit_SI',
			'MaxStrokeLength_unit_USCS',
			'MaxWheelThickness_unit_SI',
			'MaxWheelThickness_unit_USCS',
			'Min_height_unit_SI',
			'Min_height_unit_USCS',
			'Min_lifting_height_unit_SI',
			'Min_lifting_height_unit_USCS',
			'Min_ramlenght_unit_SI',
			'Min_ramlenght_unit_USCS',
			'Min_SizeBlastingMat_unit_SI',
			'Min_SizeBlastingMat_unit_USCS',
			'Min_spacing_legs_unit_SI',
			'Min_spacing_legs_unit_USCS',
			'MinRivetSize_in',
			'MinRivetSize_mm',
			'MovingPlungerMaxTravel_unit_SI',
			'MovingPlungerMaxTravel_unit_USCS',
			'PowerWeightRatio_unit_SI',
			'PowerWeightRatio_unit_USCS',
			'Reach_R_in',
			'Reach_R_mm',
			'se.atlascopco.Dimensions_lxwxh_mm',
			'SidetoCenter_unit_SI',
			'SidetoCenter_unit_USCS',
			'stroke_unit_SI',
			'stroke_unit_USCS',
			'Weight_unit_SI',
			'Weight_unit_USCS',
			'WeightWithoutReactionArm_unit_SI',
			'WeightWithoutReactionArm_unit_USCS',
			'WeightWithReactionArm_unit_SI',
			'WeightWithReactionArm_unit_USCS',
		],
	},
	Material: {
		order: 12,
		specifications: [
			'AbrasiveTypeDiegrinder',
			'AbrasiveTypeGrinder',
			'ContainerMaterial',
			'HousingMaterial',
		],
	},
	'Connectivity and display': {
		order: 10,
		specifications: [
			'AccessLevelManagement',
			'AccessPoint',
			'AdvancedSoftPLC',
			'Communicating',
			'CommunicationType',
			'ConfigurableI_O',
			'Connectivity',
			'CurvesMemoryCapacity',
			'Display',
			'EmbeddedBarcode',
			'EmbeddedEthernetSwitch',
			'EmbeddedPsetDatabase',
			'EmbeddedToolsDatabase',
			'EthernetPorts',
			'EthernetPortType',
			'ExternalBarcodeConectivity',
			'InputSignal',
			'Keyboard',
			'PCSoftwareWindows',
			'PlugPlayFieldbusModulePortOptional',
			'PlugType',
			'se.atlascopco.touch_dropdown',
			'SerialPortRS232PCTransferBarCodeReporOutput',
			'SerialPortType',
			'USBPort',
		],
	},
	General: {
		order: 11,
		specifications: [
			'AccessoriesOptional',
			'AccuracyIDAccuracy_MeasurementTool',
			'AccuracyMesurementTool',
			'AngleAccuracy',
			'AngleMeasure',
			'Application',
			'AssemblyProcessOKNOK',
			'AssemblyProcessResults',
			'AssemblyProcessResultsPerTU',
			'BatchCount',
			'CmCmkSPC',
			'ConditionsOfUse',
			'Control',
			'CVIAutocalibration',
			'EventLogStorage_NbrEvents',
			'ExportData',
			'Family',
			'FeedbackType',
			'Graduation_unit_lbf_ft_SI',
			'Graduation_unit_lbf_ft_USCS',
			'Graduation_unit_lbf_in_SI',
			'Graduation_unit_lbf_in_USCS',
			'Graduation_unit_Nm_SI',
			'Graduation_unit_Nm_USCS',
			'GreaseType',
			'IntegratedStatistics',
			'Languages',
			'MachineCapabilityTests',
			'Max_NbrCurvesSavedPerTU',
			'Max_NbrResultsSavedPerTU',
			'Max_NumberOfTools',
			'Max_NumberTU_CordlessTools',
			'Max_spacing_legs_unit_USCS',
			'Measurand',
			'Monitoring',
			'MouthpieceDelivered',
			'NbOfChannels',
			'NitrogenCompatibility',
			'Notches_number',
			'NumberPieces',
			'SubFamily',
		],
	},
	'Air information': {
		order: 9,
		specifications: [
			'AirConsumptionAtLoad_Normo_unit_SI',
			'AirConsumptionAtLoad_Normo_unit_USCS',
			'AirConsumptionAtLoad_unit_SI',
			'AirConsumptionAtLoad_unit_USCS',
			'AirFlowAtMaxPower_unit_SI',
			'AirFlowAtMaxPower_unit_USCS',
			'AirInletThreadSize',
			'AirInletThreadType',
			'FreeSpeedAirConsumption_unit_SI',
			'FreeSpeedAirConsumption_unit_USCS',
			'GaugeMaxAirPressure_unit_SI',
			'GaugeMaxAirPressure_unit_USCS',
			'Max_DynamicAirWorkingPressure_unit_SI',
			'Max_DynamicAirWorkingPressure_unit_USCS',
			'Max_workingpressure_unit_SI',
			'Max_workingpressure_unit_USCS',
			'Min_HoseDiameter16ftHoseLenght_unit_SI',
			'Min_HoseDiameter16ftHoseLenght_unit_USCS',
			'Min_HoseDiameter5mHoseLenght_unit_SI',
			'Min_HoseDiameter5mHoseLenght_unit_USCS',
			'Min_workingpressure_unit_SI',
			'Min_workingpressure_unit_USCS',
		],
	},
	'Tightening strategies': {
		order: 4,
		specifications: [
			'AdvancedTighteningStrategies',
			'TighteningDirection',
			'TighteningStrategies',
		],
	},
	Power: {
		order: 5,
		specifications: [
			'BatteryAh_unit_SI',
			'BatteryAh_unit_USCS',
			'BatteryAutonomy_SI',
			'BatteryAutonomy_USCS',
			'BatteryType',
			'BatteryVoltage',
			'Max_AmbientOperatingTemperature_unit_SI',
			'Max_AmbientOperatingTemperature_unit_USCS',
			'Max_OutputPower_unit_SI',
			'Max_OutputPower_unit_USCS',
			'Max_power_mkt_SI',
			'Max_power_mkt_USCS',
			'Max_power_unit_SI',
			'Max_power_unit_USCS',
			'Max_ramlenght_unit_USCS',
			'Max_RecommendedAmbientChargingTemperature_unit_SI',
			'Max_RecommendedAmbientChargingTemperature_unit_USCS',
			'Min_AmbientOperatingTemperature_unit_SI',
			'Min_AmbientOperatingTemperature_unit_USCS',
			'Min_RecommendedAmbientChargingTemperature_unit_SI',
			'Min_RecommendedAmbientChargingTemperature_unit_USCS',
			'se.atlascopco.Material_contains_a_battery_dropdown',
			'se.atlascopco.Type_of_battery_dropdown',
		],
	},
	Energy: {
		order: 6,
		specifications: [
			'Autonomy_h',
			'Capacitance',
			'ChargeOnCarPlug',
			'ChargeOnEngine',
			'ChargeOnSector',
			'Charger',
			'Energy_unit_SI',
			'Energy_unit_USCS',
			'EnergyType',
			'MainSupply',
			'PowerConsumption',
			'PowerSupply',
		],
	},
	'Certifications standards and directives': {
		order: 16,
		specifications: [
			'ATEX',
			'Calibrated',
			'Compliance',
			'se.atlascopco.EC_directives',
			'se.atlascopco.ISO_rig',
			'se.atlascopco.Uk_legislation',
			'se.atlascopco.WEEE_dropdown',
		],
	},
	'Accessories - Optional': {
		order: 17,
		specifications: ['BagIncluded'],
	},
	Capacity: {
		order: 7,
		specifications: [
			'FilterSurface_unit_SI',
			'FilterSurface_unit_USCS',
			'FlowRate_unit_SI',
			'FlowRate_unit_USCS',
			'GroovingCapacity_unit_SI',
			'GroovingCapacity_unit_USCS',
			'LiftingCapacities_unit_SI',
			'LiftingCapacities_unit_USCS',
			'LoadCapacity_unit_SI',
			'LoadCapacity_unit_USCS',
			'LoadingCapacity_unit_SI',
			'LoadingCapacity_unit_USCS',
			'Max_CompressionForce90psi6.2bar_unit_SI',
			'Max_CompressionForce90psi6.2bar_unit_USCS',
			'Max_LiftingCapacity_unit_SI',
			'Max_Load_SI',
			'Max_Load_USCS',
			'Min_Load_SI',
			'Min_Load_USCS',
			'NeedleCapacity',
			'Oilcapacity_unit_USCS',
			'SuctionAirflow_unit_SI',
			'SuctionAirflow_unit_USCS',
			'TankCapacity_unit_SI',
			'TankCapacity_unit_USCS',
		],
	},
	Storage: {
		order: 13,
		specifications: [
			'Max_AmbientStorageTemperature_unit_SI',
			'Max_AmbientStorageTemperature_unit_USCS',
			'Min_AmbientStorageTemperature_unit_SI',
			'Min_AmbientStorageTemperature_unit_USCS',
		],
	},
	Safety: {
		order: 15,
		specifications: [
			'IKRatings',
			'IP_code',
			'IPProtection',
			'PolarityInversionAlarm',
			'SafetyLevel',
		],
	},
	'Noise and vibrations': {
		order: 14,
		specifications: [
			'SoundPower_mkt',
			'SoundPower_unit_SI',
			'SoundPower_unit_USCS',
			'SoundPressure_unit_SI',
			'SoundPressure_unit_USCS',
			'Vibration_K_unit_SI',
			'Vibration_K_unit_USCS',
			'Vibration_mkt',
			'Vibration_unit_SI',
			'Vibration_unit_USCS',
		],
	},
}
